import { render } from "./associateUserToBranch.vue?vue&type=template&id=9a7a8996"
import script from "./associateUserToBranch.vue?vue&type=script&lang=js"
export * from "./associateUserToBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__